/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

export const solutionsPage = {
  solutions: 'Lösungen',
  connectedSolutions: 'Verknüpfte Lösungen',
  description: 'Behalte den Überblick über deine verknüpfte Lösungen.',
  date: 'Beitrittsdatum',
  toSolution: 'Zur Lösung',
  empty: {
    top: 'Du hast noch keine verknüpfte Lösungen.',
    bottom:
      'Hier findest du alle Lösungen, die mit deinem Deutschland.Digital Konto verknüpft sind.'
  },
  info: {
    title: 'Über verknüpfte Lösungen',
    content: {
      title: 'Was sind verknüpfte Lösungen?',
      message:
        'Lösungen sind digitale Dienste zur Daseinsvorsorge, die dich in unterschiedlichen Bereichen unterstützen – sei es in deinem Verein, Unternehmen oder anderen Organisationen.<br/><br/>.Bei einigen Lösungen kannst du dich mit deinem Deutschland.Digital Konto anmelden. Diese verknüpften Lösungen werden hier in deinem Nutzerprofil angezeigt.'
    }
  }
};
